<template>
  <main-layout
    class="damage"
    page-title="农机订单列表"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <el-form
        :inline="true"
        size="medium"
        :model="formInline"
        class="demo-form-inline"
        label-width="125px"
      >
        <el-form-item>
          <el-input
            v-model="formInline.keyword"
            @input="search"
            prefix-icon="el-icon-search"
            clearable
            placeholder="搜索订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            class="normal-select"
            v-model="formInline.workTypeId"
            filterable
            clearable
            @change="searchList"
            placeholder="作业类型"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="({ name, id }, index) in workTypeList"
              :key="index"
              :value="id"
              :label="name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            class="normal-select"
            v-model="formInline.status"
            filterable
            clearable
            @change="searchList"
            placeholder="全部状态"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="({ label, value }, index) in tabs"
              :key="index"
              :value="value"
              :label="label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期望作业开始时间">
          <el-date-picker
            style="width: 260px"
            v-model="formInline.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            @change="searchList"
          >
          </el-date-picker>
        </el-form-item>
        <div class="apply-btn">
          <span>{{ total ? "共" + total + "条订单" : "" }}</span>
          <el-button type="primary" size="medium" @click="applyWork">
            申请作业
          </el-button>
        </div>
      </el-form>
      <div v-loading="loading" class="box-card">
        <div v-if="list.length">
          <div class="box-contain" v-for="item in list" :key="item.id">
            <div class="left">
              <span class="left-top">
                <span class="order">订单编号：{{ item.orderNo }}</span>
                <span
                  class="status"
                  :style="{
                    color: dealStataus(item.status).color,
                    borderColor: dealStataus(item.status).color,
                  }"
                  >{{ dealStataus(item.status).label }}</span
                >
              </span>
              <span>
                <span class="left-text">作业类型：{{ item.workTypeName }}</span>
                <span class="left-text">作物：{{ item.cropGroupName }}</span>
                <span class="left-text">面积: {{ item.orderArea }}亩</span>
                <span class="left-text"
                  >期望作业时间：{{ item.expectBeginTime }}
                  至
                  {{ item.expectEndTime }}
                </span>
              </span>
            </div>
            <div class="right">
              <span class="btns">
                <el-button
                  v-if="item.status === tabs[0].value"
                  style="width: 80px"
                  type="danger"
                  size="small"
                  @click="recallDialog(item.id)"
                >
                  撤回
                </el-button>
                <el-button
                  v-if="item.status === tabs[3].value"
                  style="width: 80px"
                  type="warning"
                  size="small"
                  @click="evaluationDialog(item.id)"
                >
                  评价
                </el-button>
                <el-button
                  style="width: 80px"
                  type="primary"
                  size="small"
                  @click="goDetail(item.id)"
                >
                  详情
                </el-button>
              </span>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="!list.length">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
      <pagiation
        :total="total"
        :pageSize="formInline.pageSize"
        :pageNo="formInline.pageNo"
        @currentChange="currentChange"
        :pagisShow="pagisShow"
      />
      <el-dialog
        :visible.sync="dialogVisible"
        class="dialog"
        width="800px"
        title="撤回原因"
        :before-close="handleClose"
      >
        <el-input
          type="textarea"
          :rows="4"
          maxlength="200"
          v-model="cancelRemark"
          placeholder="请输入,200字以内"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="sureRecall">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="evaluationDialogVisible"
        class="dialog"
        width="800px"
        title="评价"
        :before-close="closeeEaluation"
      >
        <div class="dialog-box">
          <el-form ref="form" :model="form" label-width="auto">
            <el-form-item label="整体满意度：">
              <el-rate class="rate" v-model="form.rateValue"> </el-rate>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input
                type="textarea"
                :rows="4"
                maxlength="200"
                v-model="form.remark"
                placeholder="请输入，200字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="图片：">
              <div class="img-list">
                <div
                  class="img-list-item"
                  v-for="(img, idx) in form.imageUrl"
                  :key="img"
                >
                  <el-image
                    :src="setImgUrl(img, 100, 100)"
                    :preview-src-list="form.imageUrl"
                    :initial-index="idx"
                  />
                  <i class="el-icon-error" @click="removeImg(idx)"></i>
                </div>
                <el-upload
                  v-if="form.imageUrl.length < 5"
                  :action="uploadAction"
                  v-loading="uploading"
                  accept="image/jpg,image/jpeg,image/png,image/bmp,image/webp"
                  :show-file-list="false"
                  :on-change="handleFileChange"
                  :auto-upload="false"
                >
                  <div class="img-add">
                    <i class="el-icon-plus"></i>
                    上传图片
                  </div>
                </el-upload>
              </div>
              <div class="img-tip">最多上传5张，单张小于10MB</div>
            </el-form-item>
            <div class="njs-evaluation">
              <div
                class="njs-li"
                v-for="(value, index) in handList"
                :key="index"
              >
                <el-form-item class="form-flex" label="农机手：">
                  <span class="name">{{ value.name }}</span>
                  <el-rate class="rate" v-model="handList[index].score">
                  </el-rate>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input
                    type="textarea"
                    :rows="4"
                    maxlength="200"
                    v-model="handList[index].remark"
                    placeholder="请输入，200字以内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="图片：">
                  <div class="img-list">
                    <div
                      class="img-list-item"
                      v-for="(img, idx) in handList[index].imageUrl"
                      :key="img"
                    >
                      <el-image
                        :src="setImgUrl(img, 100, 100)"
                        :preview-src-list="handList[index].imageUrl"
                        :initial-index="idx"
                      />
                      <i
                        class="el-icon-error"
                        @click="removeImgs(index, idx)"
                      ></i>
                    </div>
                    <el-upload
                      v-if="handList[index].imageUrl.length < 5"
                      :action="uploadAction"
                      v-loading="handList[index].loading"
                      accept="image/jpg,image/jpeg,image/png,image/bmp,image/webp"
                      :show-file-list="false"
                      :on-change="
                        (file) => {
                          handleFilesChange(file, index);
                        }
                      "
                      :auto-upload="false"
                    >
                      <div class="img-add">
                        <i class="el-icon-plus"></i>
                        上传图片
                      </div>
                    </el-upload>
                  </div>
                  <div class="img-tip">最多上传5张，单张小于10MB</div>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeeEaluation">取 消</el-button>
          <el-button type="primary" @click="sureEvaluation">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layout/MainLayout";
import Pagiation from "@/components/Pagiation.vue";
import { windowHref } from "@/utils";
import {
  orderPageList,
  cancelOrder,
  getWorkTypeList,
  listOrderManipulator,
  giveScore,
  getNjServiceCenter,
  checkServerStation,
} from "@/api/request/snkd.njDispatch";
import { mapActions } from "vuex";
import { Nj_STATUS_TABS } from "@/confing";
import { snkd } from "@/api/api";
import { v4 as uuidv4 } from "uuid";
import { upload } from "@/api/request/snkd.foundation";
import { getStorage, setStorage } from "@/utils/storage";
import { debounce, setImgUrl } from "@/utils";
export default {
  components: {
    MainLayout,
    Pagiation,
  },
  data() {
    return {
      formInline: {
        keyword: "",
        time: "",
        pageNo: 1,
        pageSize: 20,
        workTypeId: null,
        status: null,
      },
      total: 0,
      pagisShow: false,
      queryId: null,
      list: [],
      workTypeList: [],
      tabs: Nj_STATUS_TABS,
      loading: false,
      isShow: false,
      permissionResultList: [],
      dialogVisible: false,
      evaluationDialogVisible: false,
      cancelRemark: "",
      id: null,
      form: {
        rateValue: 0, //* 评分
        remark: "", //* 整体备注
        imageUrl: [], //* 上传的图片
      },
      // 农机手评价
      handList: [], //* 农机手列表
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      njServiceCenterInfo: null,
      farmInfo: getStorage("FARMINFO"),
      // pickerDateOptions: {
      //   disabledDate(time) {
      //     return time.getTime() > Date.now();
      //   },
      // },
    };
  },
  async created() {
    await this.permissionFun();
    await this.getList();
    this.getWorkTypeList();
  },
  methods: {
    setImgUrl,
    ...mapActions("permission", ["hasPermission"]),
    async permissionFun() {
      try {
        let permissionList = [
          "agrimachinery:order",
          "agrimachinery:cancelorder",
          "agrimachinery:evaluation",
        ];
        for (let index = 0; index < permissionList.length; index++) {
          const item = permissionList[index];
          let res = await this.hasPermission(item);
          this.permissionResultList.push(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    goBack() {
      windowHref("/home/home");
    },
    async applyWork() {
      if (!this.permissionResultList[0])
        return this.$message.warning(
          "您的权限无法使用该功能，可联系超级管理员修改权限"
        );
      await this.getNjService();
      if (!(this.njServiceCenterInfo && this.njServiceCenterInfo.statusFlag)) {
        return this.$message.warning(
          "您所属区域未开通农机作业服务，请耐心等待"
        );
      }

      let serviceStationStatus = null;
      if (
        this.njServiceCenterInfo &&
        this.njServiceCenterInfo.id &&
        this.farmInfo.villageId
      ) {
        serviceStationStatus = await this.checkServerStationService();
      }
      if (!serviceStationStatus) {
        return this.$message.warning(
          "您所属区域未开通农机作业服务，请耐心等待"
        );
      }
      this.$router.push({
        path: "/NjWork/applyWork",
      });
    },
    //* 农机服务中心
    async getNjService() {
      const res = await getNjServiceCenter({
        countyId: this.farmInfo.countyId,
      });
      setStorage("NJSERVICECENTERINFO", res.obj);
      this.njServiceCenterInfo = res.obj;
    },
    //* 农机服务站
    async checkServerStationService() {
      const res = await checkServerStation({
        njCompanyId: this.njServiceCenterInfo && this.njServiceCenterInfo.id,
        villageId: this.farmInfo.villageId,
      });
      return res && res.obj;
    },
    dealStataus(status) {
      return this.tabs.find((item) => item.value === status);
    },
    // 输入框input 防抖
    search: debounce(async function () {
      this.formInline.pageNo = 1;
      this.getList();
    }),
    searchList() {
      this.formInline.pageNo = 1;
      this.getList();
    },
    currentChange(pageNo) {
      this.list = [];
      this.formInline.pageNo = pageNo;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const hasTime = this.formInline.time && this.formInline.time[0];
      try {
        const body = {
          pageNo: this.formInline.pageNo,
          pageSize: this.formInline.pageSize,
          status:
            typeof this.formInline.status === "number"
              ? this.formInline.status
              : 100,
          keyword: this.formInline.keyword,
          workTypeId: this.formInline.workTypeId,
          expectStartTimeStr: hasTime
            ? this.formInline.time[0] + " 00:00:00"
            : null,
          expectEndTimeStr: hasTime
            ? this.formInline.time[1] + " 23:59:59"
            : null,
        };
        const { obj } = await orderPageList(body);
        this.total = obj.totalCount || 0;
        this.list = obj.list || [];

        if (this.total > 20) {
          this.pagisShow = true;
        } else {
          this.pagisShow = false;
        }
        if (this.formInline.pageNo === 1) return;
        if (!obj.list.length) {
          this.formInline.pageNo--;
          return this.getList();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getWorkTypeList() {
      const res = await getWorkTypeList();
      this.workTypeList = res.obj || [];
    },
    recallDialog(id) {
      if (!this.permissionResultList[1])
        return this.$message.warning(
          "您的权限无法使用该功能，可联系超级管理员修改权限"
        );
      this.dialogVisible = true;
      this.id = id;
    },
    handleClose() {
      this.dialogVisible = false;
      this.cancelRemark = "";
    },
    async sureRecall() {
      if (!this.cancelRemark)
        return this.$message({
          message: "请输入撤回原因",
          type: "warning",
        });
      try {
        const res = await cancelOrder({
          orderId: this.id,
          cancelRemark: this.cancelRemark,
        });
        if (res.respCode == 0) {
          this.getList();
          this.$message({
            message: "撤回成功",
            type: "success",
          });
          this.handleClose();
        }
      } catch (error) {
        console.log(error);
      }
    },
    goDetail(id) {
      this.$router.push({
        path: "/NjWork/orderDetail",
        query: {
          id,
        },
      });
    },
    async evaluationDialog(id) {
      if (!this.permissionResultList[2])
        return this.$message.warning(
          "您的权限无法使用该功能，可联系超级管理员修改权限"
        );
      this.id = id;
      await this.getHandListService();
      this.evaluationDialogVisible = true;
    },
    //* 农机手列表
    async getHandListService() {
      const { obj } = await listOrderManipulator({ orderId: this.id });
      this.handList = obj.map((item) => {
        const data = {
          manipulatorId: item.id,
          name: item.name,
          score: 0,
          remark: "",
          imageUrl: [],
          loading: false,
        };
        return data;
      });
    },
    async sureEvaluation() {
      this.$message.closeAll();
      if (!this.form.rateValue)
        return this.$message({
          message: "请填写整体满意度",
          type: "warning",
        });
      const resHand = this.handList.find((item) => !item.score);
      if (resHand) {
        return this.$message({
          message: `请填写您对农机手${resHand.name}的满意度`,
          type: "warning",
        });
      }
      this.handList.forEach((item) => {
        if (item.imageUrl) {
          item.imageUrl = item.imageUrl.join(",");
        }
      });
      const res = await giveScore({
        orderId: this.id,
        orderScoreReq: {
          score: this.form.rateValue,
          remark: this.form.remark,
          imageUrl: this.form.imageUrl.join(","),
        },
        manipulatorScoreReqList: this.handList,
      });
      if (res.respCode == 0) {
        this.getList();
        this.$message({
          message: `评价成功`,
          type: "success",
        });
        this.closeeEaluation();
      } else {
        this.handList.forEach((item) => {
          if (item.imageUrl.length) {
            item.imageUrl = item.imageUrl.split(",");
          }
        });
      }
    },
    closeeEaluation() {
      this.form = {
        rateValue: 0,
        remark: "",
        imageUrl: [],
      };
      this.handList = [];
      this.evaluationDialogVisible = false;
    },
    removeImg(idx) {
      this.form.imageUrl.splice(idx, 1);
    },
    removeImgs(index, idx) {
      this.handList[index].imageUrl.splice(idx, 1);
    },
    async handleFilesChange(file, index) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.handList[index].imageUrl.length === 5) {
        this.$message.error("图片最多上传5张");
        return false;
      }
      this.handList[index].loading = true;
      const res = await this.submitFileForm(file);
      this.handList[index].loading = false;
      this.handList[index].imageUrl.push(res);
    },
    async handleFileChange(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.form.imageUrl.length === 5) {
        this.$message.error("图片最多上传5张");
        return false;
      }
      this.uploading = true;
      const res = await this.submitFileForm(file);
      this.uploading = false;
      this.form.imageUrl.push(res);
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      return await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          return uploadRet;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
          this.handList.forEach((item) => {
            item.loading = false;
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.main-content {
  width: 1200px;
  min-height: 100%;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  .apply-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #64c3a4;
  }
  .box-card {
    margin-top: 24px;
    .box-contain {
      display: flex;
      margin-bottom: 24px;
      padding: 24px 32px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .left {
        display: flex;
        flex-direction: column;
        width: 80%;
        font-size: 14px;
        color: #666;
        padding-right: 24px;
        .left-top {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          .order {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-right: 24px;
          }
          .status {
            width: 60px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            border: 1px solid;
            border-radius: 4px;
          }
        }
        .left-text {
          margin-right: 24px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 20%;

        .btns {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .dialog {
    ::v-deep .el-dialog__header {
      background-color: #64c3a4;
      text-align: center;
      padding: 15px 20px;
    }
    ::v-deep .el-dialog__title {
      color: #fff;
    }

    ::v-deep .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    ::v-deep .el-form-item__label {
      text-align: left;
    }
    ::v-deep .el-form--inline {
      display: flex;
      flex-wrap: wrap;
    }
    ::v-deep .el-form-item {
      margin-bottom: 10px;
      display: block;
      margin-right: 0;
      padding-right: 10px;
      box-sizing: border-box;
    }
  }
}
.img-list {
  display: flex;
  &-item {
    position: relative;
    line-height: 1;
    ::v-deep .el-image {
      width: 100px;
      height: 100px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .el-icon-error {
      position: absolute;
      right: 2px;
      top: -8px;
      font-size: 18px;
      background-color: #fff;
      border-radius: 50%;
      color: #dadada;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.img-add {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #c0c4cc;
  font-size: 12px;
  border: 1px solid #dcdfe5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i {
    font-size: 18px;
  }
}
.img-tip {
  font-size: 14px;
  color: #c0c4cc;
  text-align: left;
}
.dialog-box {
  max-height: 500px;
  overflow-y: auto;
}
.njs-evaluation {
  border-top: 1px solid #eee;
  .njs-li {
    background-color: #f7f9fb;
    padding: 16px 24px 10px 24px;
    margin-top: 18px;
  }
}
.form-flex {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    .name {
      color: #999;
      margin-right: 8px;
    }
  }
}
.rate {
  height: 40px;
  display: flex;
  align-items: center;
  ::v-deep .el-rate__icon {
    font-size: 22px !important;
  }
}
.nodata {
  margin-top: 180px;
}
::v-deep {
  .el-textarea__inner {
    font-family: "Microsoft YaHei";
  }
  .normal-select {
    .el-select-dropdown {
      left: 0 !important;
    }
  }
}
</style>
